<template>
    <div :style="{height:height+'px'}" class="clearfix threeStep"  v-loading="loading">
        <el-card class="complaint-card">
            <div slot="header" class="clearfix">
                <div>
                    投诉编号：<span>{{datas.rulesForm[0].complaintCode}}</span>
                </div>
                <div></div>
            </div>
            <div class="left-complain-con" :style="{height:flowHeight+'px'}">

                <div class="leftCss"></div>
                <div class="rightCss">
                    <el-row>
                        <div style="position:relative" v-for="(form,index) in datas.rulesForm" :key="index" :class="datas.rulesForm.length>1&&(((index<2||index==datas.rulesForm.length-1)&&isMore)||!isMore)?'formMultiple':''">
                            <template v-if="((index<2||index==datas.rulesForm.length-1)&&isMore)||!isMore">
                                <div class="timeline" v-if="datas.rulesForm.length>1">
                                    <span>{{Number(index)+1}}</span>
                                    <span></span>
                                </div>
                                <div v-if="form.isOpen">
                                    <el-form ref="form" :model="datas" :rules='rules' label-width="220px" class="form">
                                        <el-row>
                                            <el-col :span="10">
                                                <el-form-item label="投诉处理部门：">
                                                    {{form.handleDeptName}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                        <el-col :span="10">
                                            <el-form-item label="投诉处理结果：" :rules="rules.handleStatus" :prop="`rulesForm.${index}.handleStatus`">
                                                <el-select v-model="form.handleStatus" placeholder="请选择" @change="changeSelect(index)" :disabled="form.status!=8||!authority">
                                                    <el-option
                                                    v-for="item in dealOptions"
                                                    :key="item.value"
                                                    :label="item.name"
                                                    :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="10">
                                            <el-form-item label="处理完成时间：" :rules="rules.handleTime">
                                                <el-date-picker
                                                :disabled="true"
                                                v-model="form.handleTime"
                                                type="datetime"
                                                placeholder="选择日期">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <template v-if="form.handleStatus==1">
                                            <el-col :span="20">
                                                <el-form-item label="处理结果及依据：" :rules="rules.handleReason" :prop="`rulesForm.${index}.handleReason`">
                                                <el-input v-model="form.handleReason" maxlength="255" :rows="5" show-word-limit type="textarea" :disabled="form.status!=8||!authority"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="20">
                                                <el-form-item label="被投诉人的陈述和申辩：" :rules="rules.handleDefend" :prop="`rulesForm.${index}.handleDefend`">
                                                <el-input v-model="form.handleDefend" maxlength="255" :rows="5" show-word-limit type="textarea" :disabled="form.status!=8||!authority"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="20">
                                                <el-form-item label="监管调查认定的基本事实：" :rules="rules.handleFact" :prop="`rulesForm.${index}.handleFact`">
                                                <el-input v-model="form.handleFact" maxlength="255" :rows="5" show-word-limit type="textarea" :disabled="form.status!=8||!authority"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="20">
                                                <el-form-item label="专家意见（若有）：" :rules="rules.remark">
                                                <el-input v-model="form.remark" maxlength="255" :rows="5" show-word-limit type="textarea" :disabled="form.status!=8||!authority"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </template>
                                        <template v-else-if="form.handleStatus==2">
                                            <el-col :span="20">
                                                <el-form-item label="驳回原因：" :rules="rules.revokeReason" :prop="`rulesForm.${index}.revokeReason`">
                                                    <el-input maxlength="255" show-word-limit :rows="5" v-model="form.revokeReason" :disabled="form.status!=8||!authority" type="textarea"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="20">
                                                <el-form-item label="驳回回复：" :rules="rules.revokeReasonReply" :prop="`rulesForm.${index}.revokeReasonReply`">
                                                    <el-input maxlength="255" show-word-limit :rows="5" v-model="form.revokeReasonReply" :disabled="form.status!=8||!authority" type="textarea"></el-input>
                                                </el-form-item> 
                                            </el-col>
                                        </template>
                                        <template v-else-if="form.handleStatus==3">
                                            <el-col :span="20">
                                                <el-form-item label="转办部门：" :rules="rules.selectId" :prop="`rulesForm.${index}.selectId`">
                                                    <select-depart-tree
                                                    :ref="'selectDepartTreeRef'+index"
                                                    :selectDisabled="form.status!=8||!authority"
                                                    :modelValue.sync="selectName"
                                                    :isMultiple="false"
                                                    @handleDeptType="(val)=>changeDept(val,'deptRef')" >
                                                 </select-depart-tree>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="20">
                                                <el-form-item label="转办备注：" :rules="rules.remark">
                                                    <el-input maxlength="255" show-word-limit v-model="form.remark" :rows="5" :disabled="form.status!=8||!authority" type="textarea"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </template>
                                        <template v-else-if="form.handleStatus==4">
                                            <el-col :span="20">

                                                <el-form-item label="移交部门："  :rules="rules.selectId" :prop="`rulesForm.${index}.selectId`">
                                                    <select-depart-tree
                                                    :ref="'selectDepartTreeRef'+index"
                                                    :selectDisabled="form.status!=8||!authority"
                                                     :modelValue.sync="selectName"
                                                     :isMultiple="false"
                                                     @handleDeptType="(val)=>changeDept(val,'deptRef')" >
                                                     </select-depart-tree>

                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="20">
                                            <el-form-item label="移交备注：" :rules="rules.remark">
                                                <el-input v-model="form.remark" maxlength="255" :rows="5" show-word-limit :disabled="form.status!=8||!authority" type="textarea"></el-input>
                                            </el-form-item>
                                            </el-col>
                                        </template>
                                        <template v-else-if="form.handleStatus==5">
                                            <el-col :span="20">
                                                <el-form-item label="添加配合部门：" :rules="rules.selectId" :prop="`rulesForm.${index}.selectId`">
                                                    <select-depart-tree
                                                    :ref="'selectDepartTreeRef'+index"
                                                        :selectDisabled="form.status!=8||!authority"
                                                        :modelValue.sync="selectName"
                                                        :isMultiple="true"
                                                        @handleDeptType="(val)=>changeDept(val,'5')" >
                                                     </select-depart-tree>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="20">
                                            <el-form-item label="配合备注：" :rules="rules.remark">
                                                <el-input v-model="form.remark" maxlength="255" :rows="5" show-word-limit :disabled="form.status!=8||!authority" type="textarea"></el-input>
                                            </el-form-item>
                                            </el-col>
                                        </template>
                                        <template v-else-if="form.handleStatus==6">
                                            <el-col :span="20">
                                                <el-form-item label="移交司法/监察部门名称：" :rules="rules.selectName" :prop="`rulesForm.${index}.selectId`">
                                                    <!-- <el-select v-model="form.selectId" :disabled="form.status!=8||!authority" filterable clearable placeholder="请选择">
                                                        <el-option
                                                        v-for="item in departmentOptions"
                                                        :key="item.data.id"
                                                        :label="item.data.deptName"
                                                        :value="item.data.id">
                                                        </el-option>
                                                    </el-select> -->
                                                    <el-input v-model="form.selectId" :disabled="form.status!=8||!authority"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="20">
                                            <el-form-item label="备注：" :rules="rules.remark">
                                                <el-input v-model="form.remark" maxlength="255" :rows="5" show-word-limit :disabled="form.status!=8||!authority" type="textarea"></el-input>
                                            </el-form-item>
                                            </el-col>
                                        </template>
                                        <template v-else-if="form.handleStatus==7">
                                            <el-col :span="20">
                                                <el-form-item label="退回原因：" :rules="rules.revokeReason" :prop="`rulesForm.${index}.revokeReason`">
                                                    <el-input v-model="form.revokeReason" :rows="5" maxlength="255" show-word-limit :disabled="form.status!=8||!authority" type="textarea"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </template>
                                            <el-col :key="index" :span="20" v-for="(item,index) in form.attachments" >
                                                <el-form-item :label="item.fileTypeName?(item.fileTypeName+'：'):'附件：'" :prop="'attachments' + item.fileType" size="small"  v-if="form.status==8&&authority">
                                                    <affix-msg
                                                            :docItem.sync="item"
                                                            :docName.sync="item.name"
                                                            @uploadSuccess="uploadSuccess"
                                                    />
                                                </el-form-item>
                                                <affix-doc
                                                    :item.sync="item"
                                                    :name="item.fileTypeName"
                                                    class="affixDown"
                                                    labelWidth="220px"
                                                    v-else
                                                />
                                            </el-col>

                                            <template v-if="form.handleStatus==7">
                                                <div v-if="form.complaintSupplyVo && form.complaintSupplyVo.id">
                                                    <el-col :span="24" >
                                                       <el-divider></el-divider>
                                                    </el-col>
                                                    <el-col :span="20" >
                                                        <el-form-item label="补充提交时间：" style="margin-bottom: 8px">
                                                            <span>{{form.complaintSupplyVo.supplyTime}}</span>
                                                        </el-form-item>
                                                    </el-col>
                                                    <el-col :span="20" >
                                                        <el-form-item label="补充材料描述：" style="margin-bottom: 8px">
                                                            <span>{{form.complaintSupplyVo.remark}}</span>
                                                        </el-form-item>
                                                    </el-col>
                                                    <el-col :key="index" :span="20" v-for="(itm,index) in form.complaintSupplyVo.attachments" >
                                                        <affix-doc
                                                                :item.sync="itm"
                                                                :name="'补充材料附件'"
                                                                class="affixDown"
                                                                labelWidth="220px"
                                                        />
                                                    </el-col>
                                                </div>
                                            </template>

                                        </el-row>
                                    </el-form>
                                    <div class="imgCss">
                                        <img v-if="form.status==8" :src="require('@/assets/img/complaint/dcl.png')"/>
                                        <img v-else-if="form.status==1" :src="require('@/assets/img/complaint/ycl.png')"/>
                                        <img v-else-if="form.status==7" :src="require('@/assets/img/complaint/yth.png')"/>
                                        <img v-else-if="form.status==4" :src="require('@/assets/img/complaint/yjb.png')"/>
                                        <img v-else-if="form.status==3" :src="require('@/assets/img/complaint/yzb.png')"/>
                                        <img v-else-if="form.status==5" :src="require('@/assets/img/complaint/xhph.png')"/>
                                        <img v-else-if="form.status==2" :src="require('@/assets/img/complaint/ybh.png')"/>
                                        <img v-else :src="require('@/assets/img/complaint/yyj.png')"/>
                                    </div>
                                    <div v-if="index!=datas.rulesForm.length-1" @click="changeOpen(index)">
                                        <span class="el-icon-arrow-up away">收起</span>
                                    </div>
                                </div>
                                <div  v-else>
                                    <div class="foldBox" @click="changeOpen(index)">
                                        <img :src="require('@/assets/img/complaint/open.png')"/>
                                        <div style="flex:1">{{form.handleDeptName}}</div>
                                        <div :class="[dealColor(form.status),'typeCss'] ">{{dealType(form.status)}}</div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="datas.rulesForm.length>=4&&index==2&&isMore">
                                <div class="timeline timelines" v-if="datas.rulesForm.length>1">
                                    <span></span>
                                    <span></span>
                                </div>
                                <div class="moreBox" @click="moreFn">
                                    <img :src="require('@/assets/img/complaint/more.png')"/>
                                    <div>查看更多<span class="el-icon-arrow-down"></span></div>
                                </div>
                            </template>
                        </div>
                    </el-row>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import affixMsg from '@/components/affixMsg';
import affixDoc from '@/components/affixDoc';
import {mapState} from 'vuex'
import {apiGetDeptTree} from "@/server/configPage.js";
import selectDepartTree from "@/views/modules/components/selectDepartTree"

    export default {
    props:{
        tradeId:{
            type:String,
            defalut:''
        },
        complaintId:{
            type:String,
            defalut:''
        }
    },
    data(){
        return{
            loading:false,
            form: {
                department:'',
                user:'',
                time:'',
                deal:'',
                reason:'',
                ask:'',
                complaintCode:'',
                selectId:''
                
            },
            rules:{
                handleStatus:[{required:true, message:'请选择投诉处理结果',trigger:['change','blur']}],
                department:[{required:true, message:'请选择投诉处理部门',trigger:'blur'}],
                handleReason:[{required:true, message:'请输入投诉处理结果',trigger:['change','blur']}],
                reason:[{required:true, message:'请选择部门',trigger:['change','blur']}],
                handleDefend:[{required:true, message:'请输入陈述和申辩',trigger:'blur'}],
                handleFact:[{required:true, message:'请输入监管调查认定的基本事实',trigger:'blur'}],
                revokeReason:[{required:true, message:'请输入原因',trigger:'blur'}],
                revokeReasonReply:[{required:true, message:'请输入驳回回复',trigger:'blur'}],
                selectId:[{required:true, message:'请选择部门',trigger:'change'}],
                selectName:[{required:true, message:'请输入部门',trigger:'blur'}],
            },
            departmentOptions:[
                {
                    label:'已处理',
                    type:'1'
                },
                {
                    label:'已驳回',
                    type:'2'
                },
                {
                    label:'已转办',
                    type:'3'
                },
                {
                    label:'已移交',
                    type:'4'
                },
                {
                    label:'相互配合调查',
                    type:'5'
                },
                {
                    label:'已移交司法/监察部门',
                    type:'6'
                },
                {
                    label:'已退回',
                    type:'7'
                }
            ],
            datas:{
                rulesForm:[
                    {
                        complaintCode:'1111',
                        department:'财务',
                        user:'张三',
                        time:'2021-02-03',
                        deal:'1',
                        reason:'不是我们部门处理',
                        ask:'不是我们部门处理',
                        status:1
                    },
                ]
            },
            code:'',
            id:'',
            dealOptions:[],
            isBtn:false,
            authority:true,
            height: document.documentElement.clientHeight-320,
            flowHeight: document.documentElement.clientHeight-390,
            userOrgId:'',
            isMore:false,
            deptProps:{
                children: "children",
                label: "name",
                value:'code',
                disabled: (data, node) => {
                    return data.type === "region";
                }
            },
            deptProps_5:{
                children: "children",
                label: "name",
                value:'code',
                multiple:true,
                disabled: (data, node) => {
                    return data.type === "region";
                }
            },
            selectName:'',
            selectArr:[]
        }
    },
    filters:{
    },
    components:{
        affixMsg,
        affixDoc,
        'select-depart-tree':selectDepartTree
    },
    created(){
    },
    computed: {
        ...mapState({
            receiveSuggesstionAtt: (state) => {return  state.dataDictionary.receiveSuggesstionAtt},
        }),
    },
    mounted(){
        this.loading=true;
        if(this.$route.query.id){
            this.id=this.$route.query.id;
            this.code=this.$route.query.code;
            this.getSelectData();
        }
        this.userOrgId = this.$store.state.user.userinfo.orgInfo.orgId || '';

    },
    methods:{
        async submit(){//提交
            var index=this.datas.rulesForm.length-1;
            if(this.datas.rulesForm[index].handleStatus==6){
                this.datas.rulesForm[index].complaintTransferDepts=[{transferDeptId:null,transferDeptName:this.datas.rulesForm[index].selectId}]
            }else{
                await this.dealData(index);
            }
            // console.log(this.datas.rulesForm[index]);
            // debugger
            // this.datas.rulesForm[index].complaintCode=this.code
            this.$refs.form[(this.$refs.form.length)-1].validate((valid)=>{
                if(valid){

                    this.$httpReq({
                        url: `/complaint/handle`,
                        method: 'post',
                        data:this.datas.rulesForm[index]
                    }).then(({data}) => {
                        if(data.code==1){
                            this.$message.success(data.msg)
                            this.getCheckAuthority()
                            
                        }
                    })
                }
            })
        },
        dealData(index){//处理数据
            this.datas.rulesForm[index].complaintTransferDepts=[];
            if(this.datas.rulesForm[index].handleStatus!=5){
                  this.datas.rulesForm[index].complaintTransferDepts.push({transferDeptId:this.form.selectId,transferDeptName:this.selectName})
            }else{
                //多选时
                this.selectArr.forEach((item)=>{
                    this.datas.rulesForm[index].complaintTransferDepts.push({transferDeptId:item.code,transferDeptName:item.name})
                })
            }

        },
        // 文件上传移除
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        // 文件预览
        handlePreview(file) {
            console.log(file);
        },
        // 文件删除前的确认
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        getData(){//列表数据
            this.isBtn=false;
            this.$httpReq({
                url: `/complaint/getHandleList?complaintId=`+this.id,
                method: 'get',
                data:this.form
                }).then(({data}) => {
                    if(data.code==1){
                        var flag=false;
                        for(var i in data.data){
                            data.data[i].status=data.data[i].handleStatus;
                            if(data.data[i].handleStatus==8){
                                data.data[i].handleStatus="";
                                data.data[i].updateTime="";
                            }
                            // // 附件数据处理start
                            let attachments = JSON.parse(JSON.stringify(this.receiveSuggesstionAtt));
                            if (data.data[i].attachments && data.data[i].attachments.length > 0) {
                                data.data[i].attachments.forEach((item,index)=>{
                                    var idx = attachments.findIndex(function(it) {
                                        return it.fileType == item.fileType;
                                    });
                                    if(idx > -1){
                                        attachments[idx].id = item.id;
                                        attachments[idx].name = item.name;
                                        attachments[idx].filePath = item.filePath;
                                        attachments[idx].bizId = item.bizId;
                                    }
                                })
                            }
                            data.data[i].attachments = attachments;
                            // 附件数据处理end

                            if(data.data[i].status==8&&this.authority){
                                flag=true;
                            }
                            
                            if(data.data[i].complaintTransferDepts&&data.data[i].complaintTransferDepts.length>0){
                                if(data.data[i].handleStatus==5){
                                    data.data[i].selectId=[];
                                    for(var j in data.data[i].complaintTransferDepts){
                                        data.data[i].selectId.push(data.data[i].complaintTransferDepts[j].transferDeptId)
                                    }
                                }else if(data.data[i].handleStatus==6){
                                    data.data[i].selectId=data.data[i].complaintTransferDepts[0].transferDeptName
                                }else{
                                    data.data[i].selectId=data.data[i].complaintTransferDepts[0].transferDeptId;
                                }
                            }
                            
                        }
                        this.datas.rulesForm=data.data;
                        // 列表左侧进度线
                        this.$nextTick(()=>{
                            var ele=document.querySelectorAll('.timeline');
                            if(!ele||ele.length==0){
                                return
                            }
                            for(var i in ele){
                                ele[ele.length-1].getElementsByTagName('span')[1].style.display="block";
                            }
                            if(ele.length>0){
                                ele[ele.length-1].getElementsByTagName('span')[1].style.display="none";
                            }
                        });
                        if(this.datas.rulesForm[this.datas.rulesForm.length-1].status==8){
                            // 初始化附件数据
                            setTimeout(()=>{
                                let attachments = JSON.parse(JSON.stringify(this.receiveSuggesstionAtt));
                                this.datas.rulesForm[this.datas.rulesForm.length-1].attachments=attachments;
                                this.addFormRules(this.datas.rulesForm[this.datas.rulesForm.length-1].attachments);
                            },1000)
                        }
                        if(this.datas.rulesForm.length>1){
                            for(var i in this.datas.rulesForm){
                                if(i==(this.datas.rulesForm).length-1){
                                    this.$set(this.datas.rulesForm[i],'isOpen',true)
                                }else{
                                    this.$set(this.datas.rulesForm[i],'isOpen',false)
                                }
                                
                            }
                        }else{
                            this.$set(this.datas.rulesForm[0],'isOpen',true)
                        }
                        console.log(this.datas.rulesForm)
                        this.datas.rulesForm.length>3?this.isMore=true:this.isMore=false
                        this.isBtn=flag;
                        this.$emit('isBtn',this.isBtn)
                        
                    }else{
                        this.$message.error(data.msg)
                    } 
            }).finally(()=>{this.loading=false})
            
        },
        getSelectData(){//下拉框数据
            this.$httpReq({
                url: `/complaint/handleStatusList`,
                method: 'get',
                }).then(({data}) => {
                    if(data.code==1){
                        this.dealOptions=data.data;
                    }else{
                        this.$message.error(data.msg)
                    } 
            })

            // 现在获取部门树
            apiGetDeptTree().then(res => {
            if (res.data.code == 1) {
                let dataInfo = res.data.data;
                this.departmentOptions = dataInfo;
            }
            }).catch(() => {});

            this.getCheckAuthority()
            
        },
        changeDept(val,str){//切换部门
            // 不可选一级节点
                   if(str==='5'){
                    // 多选
                     this.selectArr=[]
                     val.forEach((item,index)=>{
                        this.selectArr.push({code:item.code,name:item.name})
                        this.datas.rulesForm[this.index].selectId=item.code
                    })
                    }else if(val.code){
                    // 单选
                    this.form.selectId=val.code
                    this.selectName=val.name
                    this.datas.rulesForm[this.index].selectId=val.code
                    }


        },
        getCheckAuthority(){//检查是否可以编辑
            this.$httpReq({
                url: `/complaint/handle/checkAuthority?complaintId=`+this.id,
                method: 'get',
                }).then(({data}) => {
                    if(data.code==1){
                        this.authority=data.data;
                        this.getData()
                    }else{
                        this.$message.error(data.msg)
                    } 
            })
        },
        // 添加表单验证规则
        addFormRules(attachments){
            const _this = this;
            attachments.length > 0 && attachments.forEach((item,index)=>{
                if(item.required){
                    let string = 'attachments' + item.fileType;
                    _this.rules[string] = [
                        {
                            required: true,
                            validator:  function(rule,value,callback){
                                if ( _this.form.attachments[index].filePath) {
                                    callback();
                                } else {
                                    callback(new Error('请上传'+_this.form.attachments[index].fileTypeName));
                                }
                            }
                        }]
                }
            })
        },
        uploadSuccess(fileType){
            this.$refs['form'].clearValidate(['attachments'+fileType]);
        },
        changeSelect(index){//切换处理结果
            this.$set(this.datas.rulesForm[index],'handleReason','')
            this.$set(this.datas.rulesForm[index],'handleDefend','')
            this.$set(this.datas.rulesForm[index],'handleFact','')
            this.$set(this.datas.rulesForm[index],'remark','')
            this.$set(this.datas.rulesForm[index],'revokeReason','')
            this.$set(this.datas.rulesForm[index],'revokeReasonReply','')
             if(this.datas.rulesForm[index].handleStatus==5){
                    this.$set(this.datas.rulesForm[index],'selectId',[])
                    this.form.selectId=[]
                }else{
                    this.$set(this.datas.rulesForm[index],'selectId','')
                    this.form.selectId=''

                }
                this.selectName=''
                this.$set(this.datas.rulesForm[index],'selectName','')
                if( this.$refs['selectDepartTreeRef'+index]&& this.$refs['selectDepartTreeRef'+index][0]){
                    this.$refs['selectDepartTreeRef'+index][0].clearhandle(1,1)
               }
                this.$nextTick(()=>{
                    this.$refs.form[(this.$refs.form.length)-1].clearValidate()
                });
            
            this.index=index
            // console.log(this.datas.rulesForm[index],this.form.selectId,this.selectArr,this.selectName,"66666");
        },
        dealType(type){//获取类型
            if(type==1){
                return '已处理'
            }else if(type==2){
                return '已驳回'
            }else if(type==3){
                return '已转办'
            }else if(type==4){
                return '已交办'
            }else if(type==5){
                return '相互配合调查'
            }else if(type==6){
                return '已移交'
            }else if(type==7){
                return '已退回'
            }
        },
        dealColor(type){//获取颜色
            if(type==1){
                return 'green'
            }else if(type==2||type==6){
                return 'red'
            }else if(type==3||type==4||type==5||type==7){
                return 'blue'
            }
        },
        changeOpen(index){//打开关闭
            this.$set(this.datas.rulesForm[index],'isOpen',!(this.datas.rulesForm[index].isOpen))
            // 回写选中的select
            this.$nextTick(()=>{
               let codeList=[]
            //    console.log(   this.$refs['selectDepartTreeRef'+index],this.datas.rulesForm[index].complaintTransferDepts);
                this.datas.rulesForm[index].complaintTransferDepts.forEach((item)=>{
                    codeList.push(item.transferDeptId)
                })
                this.$refs['selectDepartTreeRef'+index][0].reViewTreeOption('code',codeList)
            })
        },
        moreFn(){//查看更多
            this.isMore=false;
        }
    }
}
</script>

<style lang="scss" scoped>

  .threeStep{
        margin-top: 20px;
        padding-bottom: 20px;
        overflow: hidden;
        .left-complain-con{
            display: flex;
            margin: 0 auto;
            overflow: auto;
            width: 80%;
            padding-right: 20px;
            .leftCss{
                width: 100px;
            }
            .rightCss{
                flex:1;
            }
        }
        
        /deep/ .el-input{
            width: 100%!important;
        }
        .rowFormCss{
            span{
                display: inline-block;
                &:nth-of-type(1){
                    width: 208px;
                    text-align: right;
                    height: 36px;
                    line-height: 36px;
                    margin-bottom: 15px;
                    margin-right: 12px;
                    color: #606266;
                    font-weight: 600;
                }
            }
        }
        .formMultiple{
            position: relative;
            border: 1px solid #e1e1d1;
            margin-top: 16px;
            .form{
                margin-top: 20px;
            }
            /deep/ &>.el-form{
                border: 1px solid #e6e6e6;
                margin-bottom: 15px;
                padding-top: 15px;
            }
        } 
        .timeline{
            position: absolute;
            height: 100%;
            left: -40px;
            top: 0;
            span{
                display: block;
                &:nth-of-type(1){
                    width: 24px;
                    height: 24px;
                    background: #FFC500;
                    border-radius: 4px;
                    text-align: center;
                    line-height: 24px;
                    color: #ffffff;
                }
                &:nth-of-type(2){
                    width: 1px;
                    height: 100%;
                    background-color: #d8dadd;
                    margin-left: 12px;
                }
            }
        }
        .timelines{
            span{
                &:nth-of-type(1){
                    display: none;
                }
                &:nth-of-type(2){
                    width: 1px;
                    height: calc(100% + 20px);
                    background-color: #d8dadd;
                    margin-left: 13px;
                }
            }
        }
        .moreBox{
            margin: 10px 0 -6px;
            display: flex;
            div{
                cursor: pointer;
                color: #1C92FF;
                flex: 1;
                text-align: center;
            }
        }
        .btn{
            text-align: center;
            margin: 15px 0;
        }
        .imgCss{
            position: absolute;
            right: 48px;
            top: 32px;
        }
        .foldBox{
            display: flex;
            align-items: center;
            height: 48px;
            line-height: 48px;
            margin-right: 15px;
            cursor: pointer;
            div{
                color: rgba($color: #000000, $alpha: 0.85);
            }
            img{
                margin-left: 10px;
                margin-right: 6px;
            }
            .typeCss{
                margin:auto;
                height: 24px;
                line-height: 24px;
                padding: 0 11px;
            }
            .green{
                color: #3FBF00;
                border: 1px solid #3FBF00;
                background-color: rgba($color: #3FBF00, $alpha: 0.1);
            }
            .red{
                color: #F33939;
                border: 1px solid #F33939;
                background-color: rgba($color: #F33939, $alpha: 0.1);
            }
            .blue{
                color: #1C92FF;
                border: 1px solid #1C92FF;
                background-color: rgba($color: #1C92FF, $alpha: 0.1);
            }
        }
        .away{
            color: #1C92FF;
            position: absolute;
            bottom: 5px;
            right: 10px;
            cursor: pointer;
        }
    }
</style>